import { Values } from '.';

type ApiObject = Pick<Values, 'action' | 'notify'>;

const forFlow = (apiObject: ApiObject) => {
  return { ...apiObject, hasError: false };
};

const forApi = (step: { details: Values }) => {
  return {
    details: {
      ...step.details,
    },
  };
};

export const stopExecutionDTO = {
  forApi,
  forFlow,
};
